import { message, Select, Table, Typography } from "antd";
import classes from "./AppDashboard.module.scss";
import {
  accountColumns,
  billPaymentColumns,
  companyInfoColumns,
  creditedColumns,
  customerColumns,
  depositColumns,
  employeeColumns,
  estimateColumns,
  invoiceColumns,
  itemColumns,
  options,
  paymentColumns,
  purchaseOrderColumns,
  refundReceiptColumns,
  taxAgencyColumns,
  taxCodeColumns,
  taxRateColumns,
  termColumns,
  vendorColumns,
} from "./constants";
import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { fetchCategories } from "../../services/quickbooks";
const { Title, Text } = Typography;

const QuickBooksDashboard = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [dataSource, setDataSource] = useState([]);
  const [columns, setColumns] = useState([]);

  const getCategoryMutation = useMutation({
    mutationFn: fetchCategories,
    onSuccess: ({ data }) => {
      message.success("Data loaded successfully");
      setDataSource(data);
      setIsLoading(false);
    },
    onError: (error) => {
      message.error(`Oops! Something went wrong.`);
      setIsLoading(false);
    },
  });

  const handleChange = (value) => {
    setIsLoading(true);
    setSelectedCategory(value);

    switch (value) {
      case "account":
        setColumns(accountColumns);
        break;
      case "invoice":
        setColumns(invoiceColumns);
        break;
      case "bill":
        setColumns(billPaymentColumns);
        break;
      case "creditmemo":
        setColumns(creditedColumns);
        break;
      case "deposit":
        setColumns(depositColumns);
      case "estimate":
        setColumns(estimateColumns);
        break;
      case "payment":
        setColumns(paymentColumns);
        break;
      case "purchaseorder":
        setColumns(purchaseOrderColumns);
        break;
      case "refundreceipt":
        setColumns(refundReceiptColumns);
      case "salesreceipt":
        setColumns(refundReceiptColumns);
        break;
      case "customer":
        setColumns(customerColumns);
        break;
      case "employee":
        setColumns(employeeColumns);
        break;
      case "vendor":
        setColumns(vendorColumns);
        break;
      case "item":
        setColumns(itemColumns);
        break;
      case "term":
        setColumns(termColumns);
        break;
      case "taxagency":
        setColumns(taxAgencyColumns);
        break;
      case "taxcode":
        setColumns(taxCodeColumns);
        break;
      case "taxrate":
        setColumns(taxRateColumns);
        break;
      case "companyinfo":
        setColumns(companyInfoColumns);
        break;
      default:
        setColumns([]);
        break;
    }

    getCategoryMutation.mutateAsync(value);
  };

  return (
    <>
      <div className={classes.header}>
        <Title level={4} style={{ marginTop: 0 }}>
          QuickBooks App Dashboard
        </Title>
        <Text type="secondary" style={{ fontSize: 12 }}>
          Lorem Ipsum is simply dummy text of the printing and typesetting
          industry. Lorem Ipsum has been the industry's standard dummy text ever
          since the 1500s. Lorem Ipsum is simply dummy text of the printing and
          typesetting industry. Lorem Ipsum has been the industry's standard
          dummy text ever since the 1500s.
        </Text>
      </div>
      <div>
        <Select
          onChange={handleChange}
          value={selectedCategory}
          title="Select Category"
          placeholder="Please select category to load data"
          options={options}
          style={{ width: "100%", marginBottom: 20, marginTop: 20 }}
          showSearch
        />
      </div>
      <Table
        loading={isLoading}
        columns={columns}
        dataSource={dataSource || []}
        rowKey="id"
        size="small"
        scroll={{ x: 3000 }} // Enable horizontal and vertical scrolling
      />
    </>
  );
};
export default QuickBooksDashboard;
